/* eslint-disable css-modules/no-unused-class */
import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    capitalize,
    combineClasses,
} from 'wanderu-css';

import Typography from '../Typography/Typography';

import styles from './Link.scss';

function Link(props) {
    const {
        classes: classesProps,
        className,
        component: ComponentProp = 'a',
        componentProps,
        variant = 'default',
        underline = 'hover',
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProps);

    return (
        <Typography
            className={clsx(
                classes.root,
                {
                    [classes.subdued]: variant === 'subdued',
                    [classes.toc]: variant === 'toc',
                },
                classes[`underline${capitalize(underline)}`],
                className,
            )}
            component={ComponentProp}
            {...componentProps}
            {...otherProps}
        />
    );
}

Link.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    variant: PropTypes.oneOf(['default', 'subdued', 'toc']),
    underline: PropTypes.oneOf(['none', 'hover', 'always']),
    children: PropTypes.node.isRequired,
};

export default Link;
